// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__a00Ne","description-collapsed":"styles_description-collapsed__yHf0B"};